import React from 'react';

// Union of all rows' keys (not just data[0]) — merged multi-plan results
// often mix different row shapes (e.g. FillRate rows vs UsageDuration rows).
export const getColumnUnion = (data) =>
    Array.from((data || []).reduce((cols, row) => {
        Object.keys(row).forEach(key => cols.add(key));
        return cols;
    }, new Set()));

export default function TableRenderer({
    data,
    columns: providedColumns
}) {

    if (!data?.length)
        return null;

    // Callers paginating `data` should pass a pre-computed `columns` list
    // (from the full dataset) so headers stay consistent across pages.
    const columns = providedColumns || getColumnUnion(data);

    const formatColumn = (column) =>
        column
            .replaceAll("_", " ")
            .replace(/\b\w/g, char => char.toUpperCase());

    const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}T[\d:.+Z-]+$/;

    const formatCell = (value) => {
        if (value === null || value === undefined) {
            return "—";
        }

        if (typeof value === "number") {
            return value.toLocaleString();
        }

        if (typeof value === "string" && ISO_DATE_RE.test(value)) {
            const d = new Date(value);
            if (!isNaN(d)) {
                return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
            }
        }

        return value;
    };

    return (

        <section className="psd-card data-card">
            <div className="section-header">
                <div>
                    <p className="section-kicker">Data table</p>
                    <h2>Query Results</h2>
                </div>
                <span className="row-count">{data.length} rows</span>
            </div>

            <div className="table-wrap">
                <table>

            <thead>
            <tr>

                {columns.map(col => (
                    <th key={col}>
                        {formatColumn(col)}
                    </th>
                ))}

            </tr>
            </thead>

            <tbody>

            {data.map((row,index) => (

                <tr key={index}>

                    {columns.map(col => (

                        <td key={col}>
                            {formatCell(row[col])}
                        </td>

                    ))}

                </tr>

            ))}

            </tbody>

                </table>
            </div>
        </section>
    );
}
